import type * as lazyIndex from './lazyIndex';
import { LazyBootModule, LazyImport, LazyAction } from 'owa-bundling-light';

const lazyModule: LazyBootModule<typeof lazyIndex> = new LazyBootModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "AppBootToggle" */ './lazyIndex'),
    { name: 'AppBootToggle' }
);

export const lazyOutlookToggle: LazyImport<typeof lazyIndex.OutlookToggle, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.OutlookToggle);

export const lazyGetToggleStateProxy: LazyAction<
    typeof lazyIndex.lazyGetToggleState.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyGetToggleState.importAndExecute);
